import { Component, Input, OnInit } from '@angular/core';
import { MaintenanceService } from '../../services/maintenance.service';

@Component({
  selector: 'tx-maintenance-bar',
  templateUrl: './maintenance-bar.component.html',
  styleUrls: ['./maintenance-bar.component.scss'],
})
export class MaintenanceBarComponent implements OnInit {
  @Input() message: string | null | undefined;
  constructor(private maintenanceService: MaintenanceService) {}

  ngOnInit(): void {}

  dismissNotification() {
    this.maintenanceService.dismissNotification();
  }
}
